import HeaderCom from "../../components/Header.vue";
import http from "../../api/module";
import pagination from "../../components/pagination";
import { courseURL } from "../../api/baseUrl";
import fa from "element-ui/src/locale/lang/fa";
let that;
export default {
  name: "trainAppear",
  components: {
    HeaderCom,
    pagination,
  },
  data() {
    return {
      loading: false,
      currentPage: 1, // 当前页
      limit: 20, // 每页显示数量
      total: 0, // 总条目数
      currentPage2: 1, // 当前页
      limit2: 20, // 每页显示数量
      total2: 0, // 总条目数
      formInline: {},
      passValue: [],
      passValue2: [],
      passValue3: [],
      specialList: [],
      batchList: [],
      // infoList: [],
      // appear: true, // 标记上报按钮
      // noAppear: true, // 标记上报按钮
      multipleSelection: [],
      tableData: [],
      btrIds: [],
      batchDialog: false,
      innerVisible: false,
      selectBatchDialog: false,
      selectBatchId: "",
      tableDataByBatch: [],
      selectBatch: {},
      batchList2: [],
      batchForm: {},
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
    };
  },
  mounted() {
    that = this;
    this.specialList = JSON.parse(sessionStorage.getItem("specialList"));
    this.batchList = JSON.parse(sessionStorage.getItem("batchList"));
    this.getData();
    this.getReportingBatchListNotPage();
  },
  methods: {
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getData();
    },
    handleSizeChange(val) {
      this.currentPage = 1;
      this.limit = val;
      this.getData();
    },
    onSearch() {
      this.currentPage = 1;
      this.$refs.page.init();
      this.getData();
    },
    // 批量导出
    batchImport() {
      var param = "";
      var url = `${courseURL}/trainingRecord/getReportingEntpTrainingRecord?tokenId=${sessionStorage.getItem(
        "token"
      )}&entpId=${sessionStorage.getItem("entpId")}&export=1&`;
      var data = {
        regName: this.formInline.regName,
        regSex: this.formInline.sex,
        regIdcard: this.formInline.idCard,
        certificateNum: this.formInline.certificateNum,
        postId: this.formInline.postId,
        affiliatedEnterprise: this.formInline.affiliatedEnterprise,
        regBatch: this.formInline.batchId,
        approvalStatus: this.formInline.approvalStatus,
        reportingStatus: this.formInline.reportingStatus,
        dataType: this.formInline.dataType,
        approvalTimeStrat: this.passValue ? this.passValue[0] : null,
        approvalTimeEnd: this.passValue ? this.passValue[1] : null,
        reportingTimeStrat: this.passValue2 ? this.passValue2[0] : null,
        reportingTimeEnd: this.passValue2 ? this.passValue2[1] : null,
        syncTimeStrat: this.passValue3 ? this.passValue3[0] : null,
        syncTimeEnd: this.passValue3 ? this.passValue3[1] : null,
        reportingBatch: this.formInline.reportingBatch,
        syncStatus: this.formInline.syncStatus,
      };
      Object.keys(data).map((key) => {
        if (data[key] != undefined && data[key] != null) {
          url += key + "=" + data[key] + "&";
        }
      });
      // url = url.substring(url.length - 1, 1)

      console.log(url); // 输出结果  hfcrm/cm/api/user?download=1a=11&b=22&c=33
      window.location.href = url;
    },
    // 多选框选中数据
    selectionChange(val) {
      console.log(val, "val");
      this.multipleSelection = val;
      // this.appear = val.length != 1;
      this.btrIds = [];
      if (this.multipleSelection.length) {
        for (var i = 0; i < this.multipleSelection.length; i++) {
          var item = this.multipleSelection[i];
          console.log(item, "item");
          // item.reportingStatus == 0 ? this.appear = true : this.appear = false;
          /* if (item.reportingStatus == 0) {
                      this.appear = true;
                      this.noAppear = false;
                    } else {
                      this.noAppear = true;
                      this.appear = false;
                    } */
          var btrId = item.btrId;
          this.btrIds.push(btrId);
        }
      }
      // else {
      //   this.appear = true;
      //   this.noAppear = true;
      // }
    },
    // 标记为上报
    reportBtn() {
      if (this.multipleSelection.length) {
        this.$confirm("确定标记为上报吗?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.reportingTrainingRecords(0);
            this.getData();
            // this.appear = true;
          })
          .catch(() => {
            this.$message({
              type: "info",
              duration: 1000,
              message: "已取消标记上报!",
            });
          });
      } else {
        this.$message.warning({
          duration: 1500,
          message: "请先选择要上报的数据！",
        });
      }
    },
    // 标记未上报
    noReportBtn() {
      if (this.multipleSelection.length) {
        this.$confirm("确定标记为未上报吗?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.reportingTrainingRecords(1);
            this.getData();
            // this.noAppear = true;
          })
          .catch(() => {
            this.$message({
              type: "info",
              duration: 1000,
              message: "已取消标记未上报!",
            });
          });
      } else {
        this.$message.warning({
          duration: 1500,
          message: "请先选择标记未上报的数据！",
        });
      }
    },
    reportingTrainingRecords(type) {
      http
        .reportingTrainingRecords({
          recordId: this.btrIds + ",",
          type: type, // 0:已上报  1:未上报
        })
        .then((data) => {
          if (data.data.code == "200" || data.data.success == true) {
            this.$message({
              type: "success",
              duration: 1500,
              message: "操作成功!",
            });
            this.getData();
          } else {
            this.$message.error({
              duration: 1500,
              message: data.data.message,
            });
          }
        })
        .catch((error) => {});
    },
    // 获取上报列表信息
    getData() {
      http
        .getReportingEntpTrainingRecord({
          pageNum: this.currentPage,
          pageSize: this.limit,
          regName: this.formInline.regName,
          regSex: this.formInline.sex,
          regIdcard: this.formInline.idCard,
          certificateNum: this.formInline.certificateNum,
          postId: this.formInline.postId,
          affiliatedEnterprise: this.formInline.affiliatedEnterprise,
          regBatch: this.formInline.batchId,
          dataType: this.formInline.dataType,
          approvalStatus: this.formInline.approvalStatus,
          reportingStatus: this.formInline.reportingStatus,
          suspensionType : 0,
          approvalTimeStrat: this.passValue ? this.passValue[0] : null,
          approvalTimeEnd: this.passValue ? this.passValue[1] : null,
          reportingTimeStrat: this.passValue2 ? this.passValue2[0] : null,
          reportingTimeEnd: this.passValue2 ? this.passValue2[1] : null,
          syncTimeStrat: this.passValue3 ? this.passValue3[0] : null,
          syncTimeEnd: this.passValue3 ? this.passValue3[1] : null,
          reportingBatch: this.formInline.reportingBatch,
          syncStatus: this.formInline.syncStatus,
        })
        .then((data) => {
          if (data.data.code == "200" || data.data.success == true) {
            this.loading = false;
            this.tableData = data.data.data;
            this.total = data.data.total;
          } else {
            this.$message.error({
              duration: 1000,
              message: data.data.message,
            });
          }
        })
        .catch((error) => {
          this.$message.error({
            duration: 1000,
            message: "请求失败，请联系管理员！",
          });
        });
    },
    //表格数据转化
    dataTypeFormatter(row) {
      return row.dataType == 0 ? "换证" : "继教";
    },
    cellStyle({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 14) {
        return row.overStatus == 1 ? "color:#67C23A" : "color:#F56C6C";
      } else if (columnIndex === 15) {
        return row.approvalStatus == 0 ? "color:#67C23A" : "color:#F56C6C";
      } else if (columnIndex === 20) {
        return row.reportingStatus == 0 ? "color:#67C23A" : "color:#F56C6C";
      } else if (columnIndex === 22) {
        return row.isSync == 1 ? "color:#67C23A" : "color:#F56C6C";
      } else {
        return "";
      }
    },
    sexFormat(row) {
      var sex = row.sex;
      return sex == "0" ? "男" : "女";
    },
    resultFormat(row) {
      var testStatus = row.testStatus;
      return testStatus == "0" ? "合格" : "不合格";
    },
    reportFormat(row) {
      var reportingStatus = row.reportingStatus;
      return reportingStatus == "0" ? "已上报" : "未上报";
    },
    stateFormat(row) {
      var approvalStatus = row.approvalStatus;
      return approvalStatus == "0" ? "通过" : approvalStatus == "1" ? "不通过" : "待审核";
    },
    // 审核状态
    pushFormat(row) {
      var isSync = row.isSync;
      switch (isSync) {
        case 0:
          return "未推送";
        case 1:
          return "成功";
        case 2:
          return "失败";
        case 3:
          return "不推送";
        default:
          break;
      }
    },
    // 学习状态
    studyFormat(row, column) {
      var state = row.overStatus;
      return state == "1" ? "已学完" : state == "2" ? "学习中" : "待学习";
    },
    handleClick(row) {},
    managerBatch() {
      that.batchDialog = true;
      that.getReportingBatchList();
    },
    getReportingBatchList() {
      http
        .getReportingBatchList({
          pageNum: this.currentPage2,
          pageSize: this.limit2,
        })
        .then((data) => {
          if (data.data.code == "200" || data.data.success == true) {
            that.tableDataByBatch = data.data.data;
            that.total2 = data.data.total;
          } else {
            this.$message.error({
              duration: 1000,
              message: data.data.message,
            });
          }
        });
    },
    getReportingBatchListNotPage() {
      http.getReportingBatchListNotPage({}).then((data) => {
        if (data.data.code == "200" || data.data.success == true) {
          that.batchList2 = data.data.data;
        } else {
          this.$message.error({
            duration: 1000,
            message: data.data.message,
          });
        }
      });
    },
    handleCurrentChange2(val) {
      this.currentPage2 = val;
      this.getReportingBatchList();
    },
    handleSizeChange2(val) {
      this.currentPage2 = 1;
      this.limit2 = val;
      this.getReportingBatchList();
    },
    handleCurrentChangeByBatch(e) {
      that.selectBatch = e;
    },
    openSaveBatch() {
      that.innerVisible = true;
      that.batchForm = {};
    },
    openUpdateBatch() {
      if (that.selectBatch && that.selectBatch.batchId == undefined) {
        this.$message.warning({
          duration: 1000,
          message: "请选择要修改的数据",
        });
        return false;
      }
      that.innerVisible = true;
      that.batchForm = JSON.parse(JSON.stringify(that.selectBatch));
    },
    saveBatch() {
      if (that.batchForm.batchName != undefined && that.batchForm.batchName != "") {
        if (that.batchForm.batchId != undefined) {
          http
            .updateReportingBatch({
              batchName: that.batchForm.batchName,
              batchId: that.batchForm.batchId,
            })
            .then((data) => {
              if (data.data.code == "200" || data.data.success == true) {
                this.innerVisible = false;
                that.getReportingBatchList();
              } else {
                this.$message.error({
                  duration: 1000,
                  message: data.data.message,
                });
              }
            })
            .catch((error) => {
              this.$message.error({
                duration: 1000,
                message: "请求失败，请联系管理员！",
              });
            });
        } else {
          http
            .addReportingBatch({
              batchName: that.batchForm.batchName,
            })
            .then((data) => {
              if (data.data.code == "200" || data.data.success == true) {
                this.innerVisible = false;
                that.getReportingBatchList();
              } else {
                this.$message.error({
                  duration: 1000,
                  message: data.data.message,
                });
              }
            })
            .catch((error) => {
              this.$message.error({
                duration: 1000,
                message: "请求失败，请联系管理员！",
              });
            });
        }
      } else {
        this.$message.warning({
          duration: 1000,
          message: "请输入上报批次名称",
        });
      }
    },
    deleteBatch() {
      if (this.selectBatch && this.selectBatch.batchId == undefined) {
        this.$message.warning({
          duration: 1000,
          message: "请选择要删除的数据",
        });
        return false;
      }
      this.$confirm("确定删除该条数据吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          http
            .deleteReportingBatch({
              batchId: that.selectBatch.batchId,
            })
            .then((data) => {
              if (data.data.code == "200" || data.data.success == true) {
                that.getReportingBatchList();
                that.selectBatch = {};
              } else {
                this.$message.error({
                  duration: 1000,
                  message: data.data.message,
                });
              }
            })
            .catch((error) => {
              this.$message.error({
                duration: 1000,
                message: "请求失败，请联系管理员！",
              });
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            duration: 1000,
            message: "已取消删除!",
          });
        });
    },
    openReportingBatch() {
      if (that.multipleSelection.length > 0) {
        that.selectBatchDialog = true;
        that.getReportingBatchList();
      } else {
        this.$message.warning({
          duration: 1000,
          message: "请选择要操作的数据!",
        });
      }
    },
    setReportingBatch() {
      if (that.selectBatchId == "") {
        this.$message.warning({
          duration: 2000,
          message: "请选择上报批次!",
        });
        return false;
      }
      var btrIds = "";
      that.multipleSelection.forEach(function(mObj) {
        btrIds = btrIds + mObj.btrId + ",";
      });

      http
        .setReportingBatch({
          btrIds: btrIds,
          batchId: that.selectBatchId,
        })
        .then((data) => {
          if (data.data.code == "200" || data.data.success == true) {
            that.onSearch();
            that.selectBatchId = "";
            that.multipleSelection = [];
            this.$message.success({
              duration: 1000,
              message: "保存成功",
            });
            that.selectBatchDialog = false;
          } else {
            this.$message.error({
              duration: 1000,
              message: data.data.message,
            });
          }
        })
        .catch((error) => {
          this.$message.error({
            duration: 1000,
            message: "请求失败，请联系管理员！",
          });
        });
    },
  },
};
